import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import { ErrorBoundary } from '@sentry/react';
import { initializeSentryScope, isSentryAllowed } from "./sentry";

/**
 *  Обертка Sentry, отсылающая ошибки в Sentry
 *  withIsolationScope повзоляет запускать дополнительный клиент,
 *  что позволяет иметь несколько реализаций Sentry на одной странице,
 *  т.н. multi-client реализация. Т.к. в Header проекта адаптив уже есть
 *  инициализация Sentry клиента.
 * */
export var withSentryHOC = function withSentryHOC(WrappedComponent) {
  if (!isSentryAllowed()) return WrappedComponent;
  initializeSentryScope();
  return function (_ref) {
    var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/React.createElement(ErrorBoundary, {
      "data-t-id": "components-WithSentryHOC"
    }, /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, {
      "data-t-id": "components-WithSentryHOC"
    }), children));
  };
};